import { CoreInitiativesName } from './name';
import { getInitiatives } from '@api';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';

import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreInitiativesGetAsyncSlice = createGetAsyncSlice({
	defaultRequest: {
		assignedTos: [],
		count: 20,
		key: '',
		paginationDirection: PaginationDirection.Forward,
		sortBy: 'createdOn',
		sortDirection: 'descending',
		statuses: [],
		title: ''
	},
	name: CoreInitiativesName,
	receive: true,
	request: true,
	requestHandler: getInitiatives,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
